import React from "react";
import { Link as RouterLink, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { TextField, Typography, Box, Link } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { ButtonLoader } from "frontend/src/ui/button-loader";
import { CircleLogo } from "frontend/src/ui/circle-logo";
import { useResetPassword } from "frontend/src/features/reset-password";
import { paths } from "frontend/src/pages/paths/index";
import { MultilineHelperText } from "frontend/src/ui/multiline-helper-text";
import { locales } from "frontend/src/domain/localization/i18n";
import { GuestUserLayout } from "frontend/src/pages/layouts/guest-user-layout";
var useStyles = makeStyles(function (theme) { return ({
    paper: {
        marginTop: theme.spacing(8),
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
    },
    avatar: {
        margin: theme.spacing(1),
    },
    form: {
        width: "100%",
        marginTop: theme.spacing(1),
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
    error: {
        color: "red",
    },
}); });
var useRestorePasswordToken = function () { var _a; return (_a = new URLSearchParams(useLocation().search).get("token")) !== null && _a !== void 0 ? _a : ""; };
var Page = function () {
    var _a, _b;
    var t = useTranslation(locales.namespaces.guest).t;
    var t2 = useTranslation(locales.namespaces.shared).t;
    var classes = useStyles();
    var token = useRestorePasswordToken();
    var _c = useResetPassword(), success = _c.success, reset = _c.reset, password = _c.password, email = _c.email, errors = _c.errors, pending = _c.pending;
    var onPasswordFieldChange = function (evt) {
        return password.set(evt.target.value);
    };
    var onEmailFieldChange = function (evt) {
        return email.set(evt.target.value);
    };
    var onSubmit = function (evt) {
        evt.preventDefault();
        reset(token);
    };
    return success ? (React.createElement(Box, { mt: 4 },
        React.createElement(Typography, { variant: "h5" }, t("pages.resetPassword.successMessage")),
        React.createElement(Typography, { variant: "body2" },
            React.createElement(Link, { component: RouterLink, to: paths.login() }, t("pages.resetPassword.back"))))) : (React.createElement(Box, null,
        React.createElement("div", { className: classes.paper },
            React.createElement(CircleLogo, { className: classes.avatar }),
            React.createElement(Typography, { component: "h1", variant: "h5" }, t("pages.resetPassword.header")),
            React.createElement("form", { className: classes.form, noValidate: true, onSubmit: onSubmit },
                React.createElement(TextField, { variant: "outlined", margin: "normal", required: true, fullWidth: true, label: t("pages.resetPassword.email"), type: "email", autoFocus: true, autoComplete: "email", disabled: pending, error: !!errors.email, helperText: React.createElement(MultilineHelperText, { texts: (_a = errors.email) !== null && _a !== void 0 ? _a : [] }), value: email.value, onChange: onEmailFieldChange }),
                React.createElement(TextField, { variant: "outlined", margin: "normal", required: true, fullWidth: true, label: t("pages.resetPassword.newPassword"), autoFocus: true, autoComplete: "current-password", type: "password", disabled: pending, error: !!errors.password, helperText: React.createElement(MultilineHelperText, { texts: (_b = errors.password) !== null && _b !== void 0 ? _b : [] }), value: password.value, onChange: onPasswordFieldChange }),
                errors.unknown && (React.createElement(Box, null,
                    React.createElement(Typography, { className: classes.error, variant: "caption" }, t2("errors.unknown")))),
                React.createElement(ButtonLoader, { isLoading: pending, type: "submit", fullWidth: true, variant: "contained", color: "primary", className: classes.submit }, t("pages.resetPassword.submit"))))));
};
export var ResetPasswordPage = function () { return (React.createElement(GuestUserLayout, null,
    React.createElement(Page, null))); };
